// import "../Users/Users.scss"; // Removed for version update
import React, { useState, useEffect } from "react";
import axios from "axios";
// import store from "../../../store";
import { toast } from "react-toastify";

const AddShopifyMerchant = ({ searchFlag, setSearchFlag }) => {
  const [formData, setFormData] = useState({
    app_id: "",
    app_secret: "",
    website: "",
    businessName: "",
  });

  let token = localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    authorization: token,
  };

  const [submitFlag, setSubmitFlag] = useState(0);

  const onSubmit = (e) => {
    e.preventDefault();
    setSubmitFlag(1);
    if (
      formData.businessName != "" &&
      formData.app_id != "" &&
      formData.app_secret != "" &&
      formData.website != ""
    ) {
      axios
        .post(
          process.env.BASE_URL + "/api/merchant/create",
          {
            business_name: formData.businessName,
            app_id: formData.app_id,
            app_secret: formData.app_secret,
            website: formData.website,
          },
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.data.status_code == 200) {
            toast.success("Merchant Added", {
              position: "top-center",
              autoClose: 1500,
            });
            ColseModal();
          } else
            toast.error("Operation Failed", {
              position: "top-center",
              autoClose: 1500,
            });
        })
        .catch(() => {
          toast.error("Operation Failed", {
            position: "top-center",
            autoClose: 1500,
          });
        });
    }
  };

  const ColseModal = () => {
    document.getElementById("go-modal").classList.remove("open");
    setFormData({
      app_id: "",
      app_secret: "",
      website: "",
      businessName: "",
    });
    setSearchFlag(!searchFlag);
    setSubmitFlag(0);

    // setError({
    //   name: false,
    //   email: false,
    //   phone: false,
    //   role_id: false,
    // });
  };

  return (
    <div className="go-modal" id="go-modal">
      <div className="overlay"></div>
      <div className="go-modal-card">
        <a className="close-modal" onClick={ColseModal} href="javascript:;">
          <img src="/images/close.svg" />
        </a>
        <div className="go-modal-header">
          <h3 class="fs20 lh-25 metro-m text-d-blue margin-t10">
            Add New Merchant
          </h3>
        </div>
        <div className="go-modal-content">
          <form className="add-merchant">
            <div className="form-group">
              <label
                className="fs14 lh-14 text-l-blue metro-r margin-b8"
                htmlFor="business"
              >
                <span className="text-danger">*</span> Business Name
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Business Name"
                value={formData.businessName}
                id="business"
                onChange={(e) =>
                  setFormData({ ...formData, businessName: e.target.value })
                }
              />
              <p
                className={`error fs12 lh-12 text-error text-right metro-r margin-t5 ${
                  formData.businessName == "" && submitFlag == true
                    ? ""
                    : "hide"
                }`}
              >
                Invalid Business Name
              </p>
            </div>

            <div className="form-group">
              <label
                className="fs14 lh-14 text-l-blue metro-r margin-b8"
                htmlFor="app_id"
              >
                <span className="text-danger">*</span>App ID
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter App ID"
                id="app_id"
                value={formData.app_id}
                onChange={(e) =>
                  setFormData({ ...formData, app_id: e.target.value })
                }
              />
              <p
                className={`error fs12 lh-12 text-error text-right metro-r margin-t5 ${
                  formData.app_id == "" && submitFlag == true ? "" : "hide"
                }`}
              >
                Invalid App ID
              </p>
            </div>
            <div className="form-group">
              <label
                className="fs14 lh-14 text-l-blue metro-r margin-b8"
                htmlFor="app_secret"
              >
                <span className="text-danger">*</span>App Secret
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter App Secret"
                id="app_secret"
                value={formData.app_secret}
                onChange={(e) =>
                  setFormData({ ...formData, app_secret: e.target.value })
                }
              />
              <p
                className={`error fs12 lh-12 text-error text-right metro-r margin-t5 ${
                  formData.app_secret == "" && submitFlag == true ? "" : "hide"
                }`}
              >
                Invalid App Secret
              </p>
            </div>

            <div className="form-group">
              <label
                className="fs14 lh-14 text-l-blue metro-r margin-b8"
                htmlFor="website"
              >
                <span className="text-danger">*</span>Website
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Website"
                value={formData.website}
                id="website"
                onChange={(e) =>
                  setFormData({ ...formData, website: e.target.value })
                }
              />
              <p
                className={`error fs12 lh-12 text-error text-right metro-r margin-t5 ${
                  formData.website == "" && submitFlag == true ? "" : "hide"
                }`}
              >
                Invalid Website
              </p>
            </div>

            <div className="form-group margin-t40 text-right">
              <button className="blue-btn auto-w-btn" onClick={onSubmit}>
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddShopifyMerchant;
